var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M83.333,43.333h-6.666v30.001h-13.33l-3.334,3.332h-20l-3.336-3.332H23.333V33.333 c0-1.836,1.498-3.333,3.334-3.333H50v-6.667H26.667c-5.521,0-10,4.476-10,10v40.001H10c0,5.52,4.477,10,10,10h60 c5.521,0,10-4.477,10-10h-6.667V43.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M83.333,23.333V20c0-1.836-1.497-3.334-3.333-3.334H60c-1.829,0-3.333,1.498-3.333,3.334v13.333 c0,1.828,1.504,3.333,3.333,3.333h20c1.836,0,3.333-1.505,3.333-3.333V30L90,36.666v-20L83.333,23.333z M76.667,30H63.333v-6.667 h13.334V30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50,43.333C50,47.016,47.02,50,43.333,50c-3.685,0-6.666-2.984-6.666-6.667c0-3.681,2.981-6.667,6.666-6.667 C47.02,36.666,50,39.652,50,43.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.667,56.666L40,56.67c-5.521,0-10,4.477-10,9.996h26.667C56.667,61.146,52.193,56.666,46.667,56.666z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingTimer);
export default __webpack_public_path__ + "static/media/meeting-timer.fc68e57dbfc65cb4847254b39a411e93.svg";
export { ForwardRef as ReactComponent };